import React, { useEffect, useLayoutEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Style/typo.css";
import "./assets/css/style-page2.css";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import Desk1 from "./assets/image/desk1.png";
import Desk2 from "./assets/image/desk2.png";
import Desk3 from "./assets/image/desk3.png";
import Desk4 from "./assets/image/desk4.png";
import Desk5 from "./assets/image/desk5.png";
import Desk6 from "./assets/image/desk6.png";
import Desk7 from "./assets/image/desk7.png";
import Desk8 from "./assets/image/desk8.png";
import Desk9 from "./assets/image/desk9.png";
import Desk10 from "./assets/image/desk10.png";
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";

function HelpDeskMain() {
    const scrollToId = (id, offset = 80) => {
        const el = document.getElementById(id);
        if (!el) return;
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: "smooth" });
    };

    return (
        <div>
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />

            <div>
                <div className="desk-banner">
                    <div className="desk-w17 w-smaller">
                        <FadeInSection>
                            <div className="desk-wrap">
                                <div className="desk-box m-l-30">
                                    <div>
                                        <p className="typo-32-mb wh-color">헬프데스크란 ?</p>
                                        <p className="typo-21-sm wh-color">
                                            메일, 라이브챗, 전화 등 여러 채널로 <br />
                                            들어오는 고객문의를 “헬프데스크” <br />
                                            라는 하나의 통합된 컨텍센터에서 관리합니다.
                                        </p>
                                        <p className="typo-21-sm wh-color">
                                            담당자 배정 및 상태변경 , 메일 답변을 <br />
                                            지원하고 내부 구성원 및 고객과 공유합니다.
                                        </p>
                                    </div>

                                    <div class="feature-btn-gr theme-purple">
                                        <a class="url-btn typo-14" href="https://hanbiro.com/#/groupware-free-trial">
                                            <button class="btn--default btn--primary">데모 신청</button>
                                        </a>
                                        <a class="url-btn typo-14" href="https://hanbiro.com/#/pricing">
                                            <button class="btn--default btn--secondary">요금안내</button>
                                        </a>
                                    </div>
                                </div>
                                <div className="desk-box">
                                    <div className="desk-box-img">
                                        <img src="http://hanbiro.com/assets/images/cloud/hanbiro-helpdesk-illustration-1.png" alt="desk1" />
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                    </div>
                </div>

                <div>
                    <div>
                        <div className="desk-block desk-block-1">
                            <div className="desk-w17">
                                <FadeInSection>
                                    <div className="bg-neutral bg-custom">
                                        <div className="desk-title">
                                            <p className="typo-32-mb t-pl">AI 전화</p>
                                            <p className="typo-16">PC팝업을 통하여 고객정보를 미리확인하고, 고객과의 모든 통화 이력을 저장·관리하는 솔루션입니다.</p>
                                            <p className="typo-16">AI 기술을 통하여 통화 내용을 텍스트로 추출하고 번역 및 요약 기능을 제공합니다.</p>
                                        </div>
                                        <div className="desk-block-content">
                                            <div className="desk-block-wrap">
                                                <div className="desk-block-box">
                                                    <p class="typo-21">
                                                        <b>전화 수신 팝업</b>
                                                    </p>
                                                    <ul className="desk-ul">
                                                        <li className="typo-16">PC 팝업으로 고객 정보를 사전에 확인하고, 과거 통화 이력을 참고하여 응대합니다.</li>
                                                        <li className="typo-16">미등록 번호를 저장 시, 기존 고객 연락처에 실시간으로 자동 업데이트됩니다.</li>
                                                        <li className="typo-16">통화가 끝난 후 저장 하면,통화 내용이 녹취 파일로 보관됩니다.</li>
                                                    </ul>
                                                </div>
                                                <div className="desk-block-box">
                                                    <div className="desk-block-box-img-w17 border-blue m-l-30">
                                                        <img src="https://hanbiro.com/assets/images/cloud/helpdesk-call-crmcall-605x350.png" />
                                                        {/* <p class="img-description bg-blue">전화 수신 팝업</p> */}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="desk-block-wrap desk-block-wrap-right">
                                                <div className="desk-block-box">
                                                    <div className="desk-block-box-img-w17 border-blue m-r-30">
                                                        <img src="https://hanbiro.com/assets/images/cloud/helpdesk-call-view-605x350.png" />
                                                        {/* <p class="img-description bg-blue">전화 이력 관리 화면</p> */}
                                                    </div>
                                                </div>
                                                <div className="desk-block-box">
                                                    <p class="typo-21">
                                                        <b>전화 이력 관리 화면</b>
                                                    </p>
                                                    <ul className="desk-ul">
                                                        <li className="typo-16">통화 이력에 대하여 녹취파일 & 메모 를 확인합니다.</li>
                                                        <li className="typo-16">통화 내용에 대하여 내용 요약 및 번역, 전화 내용 텍스트 변환하여 보여줍니다.</li>
                                                        <li className="typo-16">부재중 전화 이력을 확인합니다.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FadeInSection>
                            </div>
                        </div>
                    </div>

                    {/* <div className="line-block line-block-1 desk-w17" /> */}
                    <div>
                        <div className="desk-block">
                            <div className="desk-w17">
                                <FadeInSection>
                                    <div className="bg-blue bg-custom">
                                        <div className="desk-title">
                                            <p className="typo-32-mb t-pl helpdesk-h-blue">티켓</p>
                                            <p className="typo-16">고객이 보낸 메일을 티켓으로 자동 등록합니다.</p>
                                            <p className="typo-16">담당자 배정부터 상태 변경, 답변 처리까지 체계적으로 관리합니다.</p>
                                            <p className="typo-16">티켓은 진행 단계별로 명확히 구분되어 업무 누락 없이 신속하게 대응합니다.</p>
                                        </div>
                                        <div className="desk-block-content">
                                            <div className="desk-block-wrap">
                                                <div className="desk-block-box">
                                                    <p class="typo-21">
                                                        <b>티켓 조회 화면</b>
                                                    </p>
                                                    <ul className="desk-ul">
                                                        <li className="typo-16">고객이 대표메일로 문의한 것을 티켓화합니다.</li>
                                                        <li className="typo-16">각 문의에 대한 담당자와 우선순위를 한눈에 확인합니다.</li>
                                                        <li className="typo-16">배정되지 않은 티켓을 따로 표기하여 누락되지 않도록 지원합니다.</li>
                                                    </ul>
                                                </div>
                                                <div className="desk-block-box">
                                                    <div className="desk-block-box-img-w17 border-blue m-l-30">
                                                        <img src="https://hanbiro.com/assets/images/cloud/helpdesk-ticket-view-605x350.png" />
                                                        {/* <p class="img-description bg-blue">티켓 조회 화면</p> */}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="desk-block-wrap desk-block-wrap-right">
                                                <div className="desk-block-box">
                                                    <div className="desk-block-box-img-w17 border-blue m-r-30">
                                                        <img class="img-p-5" src="https://hanbiro.com/assets/images/cloud/helpdesk-ticket-view-ai-605x350.png" />
                                                        {/* <p class="img-description bg-blue"> 티켓 요약 & 번역</p> */}
                                                    </div>
                                                </div>
                                                <div className="desk-block-box">
                                                    <p class="typo-21">
                                                        <b>티켓 요약 & 번역</b>
                                                    </p>
                                                    <ul className="desk-ul">
                                                        <li className="typo-16">고객이 문의한 내용에 대해 요약 및 번역 기능을 제공합니다.</li>
                                                        <li className="typo-16">고객의 문의사항을 처리할 담당자를 자동 할당 및 수동 배정합니다.</li>
                                                        <li className="typo-16">각 문의에 대한 카테고리 및 상태를 변경합니다.</li>
                                                        <li className="typo-16">해당 용어는 회사에 맞게 커스텀합니다.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FadeInSection>
                            </div>
                        </div>
                    </div>

                    {/* <div className="line-block desk-w17" /> */}

                    <div>
                        <div className="desk-block">
                            <div className="desk-w17">
                                <FadeInSection>
                                    <div className="bg-neutral bg-custom">
                                        <div className="desk-title">
                                            <p className="typo-32-mb t-pl">라이브챗</p>
                                            <p className="typo-16">라이브챗을 통해 고객과 실시간 상담한 내역을 저장하고 관리합니다.</p>
                                            <p className="typo-16">상담 이력은 자동으로 저장되며 , AI가 대화 내용을 요약 해 핵심을 빠르게 파악합니다.</p>
                                        </div>
                                        <div className="desk-block-content">
                                            <div className="desk-block-wrap">
                                                <div className="desk-block-box">
                                                    <p class="typo-21">
                                                        <b>라이브챗 조회 화면</b>
                                                    </p>
                                                    <ul className="desk-ul">
                                                        <li className="typo-16">고객과의 라이브챗 상담 내용을 확인합니다.</li>
                                                        <li className="typo-16">상담 내용을 요약하여 간략하게 제공합니다.</li>
                                                        <li className="typo-16">상담 내용을 기존 고객과 연동하면.</li>
                                                        <li className="typo-16">고객관리{" > "}영업활동 메뉴에 히스토리로 표출됩니다.</li>
                                                        <li className="typo-16">상담내용에 대하여 요약·번역 기능을 제공합니다.</li>
                                                    </ul>
                                                </div>
                                                <div className="desk-block-box">
                                                    <div className="desk-block-box-img-w17 border-blue m-l-30">
                                                        <img src="https://hanbiro.com/assets/images/cloud/helpdesk-livechat-view-605x350.png" />
                                                        {/* <p class="img-description bg-blue">라이브챗 조회 화면</p> */}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="desk-block-wrap desk-block-wrap-right">
                                                <div className="desk-block-box">
                                                    <div className="desk-block-box-img-w17 border-blue m-r-30">
                                                        <img src="https://hanbiro.com/assets/images/cloud/helpdesk-livechat-log-605x350.png" />
                                                        {/* <p class="img-description bg-blue">라이브챗 요약</p> */}
                                                    </div>
                                                </div>
                                                <div className="desk-block-box">
                                                    <p class="typo-21">
                                                        <b>라이브챗 요약</b>
                                                    </p>
                                                    <ul className="desk-ul">
                                                        <li className="typo-16 live-chat-mw">고객과의 라이브챗 상담 내용을 날짜로 검색하여 해당 일자의 요약 내용을 한눈에 봅니다.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FadeInSection>
                            </div>
                        </div>
                    </div>

                    {/* <div className="line-block desk-w17" /> */}
                    <div>
                        <div className="desk-block">
                            <div className="desk-w17">
                                <FadeInSection>
                                    <div className="bg-blue bg-custom">
                                        <div className="desk-title">
                                            <p className="typo-32-mb t-pl helpdesk-h-blue">고객관리</p>
                                            <p className="typo-16">고객 정보를 등록하고 , 상담/문의/미팅 등 고객의 모든 활동 이력을 헬프데스크 한 곳에서 통합 관리합니다.</p>
                                            <p className="typo-16">고객의 이력을 한 눈에 파악하여 , 일관된 고객 응대를 지원합니다.</p>
                                        </div>
                                        <div className="desk-block-content">
                                            <div className="desk-block-wrap">
                                                <div className="desk-block-box">
                                                    <p class="typo-21">
                                                        <b>고객 정보 등록 및 조회</b>
                                                    </p>
                                                    <ul className="desk-ul">
                                                        <li className="typo-16">등록된 고객에 대해 고객그룹과 담당자를 확인합니다.</li>
                                                        <li className="typo-16">등록된 고객의 대표 번호와 메일주소를 확인합니다.</li>
                                                        <li className="typo-16">통합검색을 통해 이름, 이메일, 전화, 주소, 담당자, 고객그룹 등 을 검색합니다.</li>
                                                    </ul>
                                                </div>
                                                <div className="desk-block-box">
                                                    <div className="desk-block-box-img-w17 border-blue m-l-30">
                                                        <img src="https://hanbiro.com/assets/images/cloud/helpdesk-customers-view-add-605x350.png" alt="desk8" />
                                                        {/* <p class="img-description bg-blue">고객 정보 등록 및 조회</p> */}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="desk-block-wrap desk-block-wrap-right">
                                                <div className="desk-block-box">
                                                    <div className="desk-block-box-img-w17 border-blue m-r-30">
                                                        <img src="https://hanbiro.com/assets/images/cloud/helpdesk-customers-view-605x350.png" alt="desk9" />
                                                        {/* <p class="img-description bg-blue">고객별 히스토리 조회</p> */}
                                                    </div>
                                                </div>
                                                <div className="desk-block-box">
                                                    <p class="typo-21">
                                                        <b>고객별 히스토리 조회</b>
                                                    </p>
                                                    <ul className="desk-ul">
                                                        <li className="typo-16">해당 고객과 진행한 활동이력을 모아봅니다.</li>
                                                        <li className="typo-16">고객의 정보 및 특이사항에 대해 메모를 남깁니다.</li>
                                                        <li className="typo-16">고객과 주고받은 첨부파일들을 모아봅니다.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FadeInSection>
                            </div>
                        </div>
                    </div>

                    <div className="desk-banner-bottom">
                        <div className="desk-w17">
                            <FadeInSection>
                                <div className="desk-wrap">
                                    <div className="desk-box">
                                        <div>
                                            <p className="typo-32-mb t-pl">지식창고·기업전용 LLM챗봇</p>
                                            <p className="typo-16">기업 내부의 방대한 문서와 자료를 체계적으로 관리합니다.</p>
                                            <p className="typo-16">
                                                지식창고에 업로드 한 자료를 기반으로, 직원이 질문하면 <br />
                                                LLM챗봇이 즉시 답변하는 맞춤형 서비스입니다.
                                            </p>
                                            <p className="typo-16">이를 통해 필요한 정보를 빠르게 찾아 업무 효율을 높입니다.</p>
                                        </div>
                                    </div>
                                    <div className="desk-box">
                                        <div className="desk-block-box-img-w17 border-blue m-l-30">
                                            <img src="https://hanbiro.com/assets/images/cloud/helpdesk-knowledgebase-view-605x350.png" />
                                        </div>
                                    </div>
                                </div>
                            </FadeInSection>
                        </div>
                    </div>

                    <div className="desk-block desk-block-1">
                        <div className="desk-w17">
                            <FadeInSection>
                                <div className="typo-32 desk-block-title t-pl">헬프데스크 장점</div>

                                <div className="desk-benefit">
                                    <div className="desk-benefit-item-w17">
                                        <div className="benefit-item-title">
                                            <p className="typo-21-sm typo-medium">고객 관리 솔루션 하나로 통합</p>
                                        </div>

                                        <ul className="desk-ul">
                                            <li className="typo-16">이력관리로 고객 민원 감소</li>
                                            <li className="typo-16">모든 문의를 한 곳에서 관리</li>
                                            <li className="typo-16">일관성 있는 답변으로 만족도 향상</li>
                                        </ul>
                                    </div>
                                    <div className="desk-benefit-item-w17">
                                        <div className="benefit-item-title">
                                            <p className="typo-21-sm typo-medium">중소기업 맞춤 간소화 기능</p>
                                        </div>

                                        <ul className="desk-ul">
                                            <li className="typo-16">초기 설정이 간단하고 교육 불필요</li>
                                            <li className="typo-16">담당자별 업무현황 파악</li>
                                            <li className="typo-16">인력 자원 효율 배분</li>
                                        </ul>
                                    </div>
                                    <div className="desk-benefit-item-w17">
                                        <div className="benefit-item-title">
                                            <p className="typo-21-sm typo-medium">그룹웨어 사용 시 Free</p>
                                        </div>

                                        <ul className="desk-ul">
                                            <li className="typo-16">한비로 그룹웨어 이용 고객</li>
                                            <li className="typo-16">헬프데스크 기능 무료 제공</li>
                                        </ul>
                                    </div>
                                </div>
                            </FadeInSection>
                        </div>
                    </div>
                </div>
            </div>

            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default HelpDeskMain;
